import React from 'react'
import { useSelector } from 'react-redux'
import Accessibility from 'highcharts/modules/accessibility'
import ExportData from 'highcharts/modules/export-data'
import Exporting from 'highcharts/modules/exporting'
import Highcharts from 'highcharts'
import SolidGauge from 'highcharts/modules/solid-gauge'
import VariablePie from 'highcharts/modules/variable-pie'
import { ApplicationState } from 'src/store'
import { PageHeader } from 'src/components/Ant'
import { DashboardDiv } from './components/chart.styles'
import ApprovalsPending from './charts/approvals_pending'
import CcChart from './charts/cc_chart'
import ConferencesPending from './charts/conferences_pending'
import CostChart from './charts/cost_chart'
import ReceiptsByUser from './charts/receipts_by_user'
import ServicesChart from './charts/services_chart'
import Travelers from './charts/travelers'

require('highcharts/highcharts-more')(Highcharts)
Accessibility(Highcharts)
ExportData(Highcharts)
Exporting(Highcharts)
SolidGauge(Highcharts)
VariablePie(Highcharts)

export default function DashBoard() {
  const { organization_id } = useSelector((state: ApplicationState) => ({
    organization_id: state.me.organization.organization_id
  }))

  return (
    <>
      <PageHeader title="web.dashboard" />
      <DashboardDiv>
        <ApprovalsPending organization_id={organization_id} />
        <ConferencesPending organization_id={organization_id} />
        <CcChart organization_id={organization_id} />
        <CostChart organization_id={organization_id} />
        <ReceiptsByUser organization_id={organization_id} />
        <ServicesChart organization_id={organization_id} />
        <Travelers organization_id={organization_id} />
      </DashboardDiv>
    </>
  )
}
